export default __webpack_public_path__ + "static/propos-7dd58e234f0d8104e8e89a4011fa56f6.png";